import { Spin, BackTop } from 'antd';

import classNames from 'classnames';

import parse from 'html-react-parser';
import months from '../months.json';

import useQuery from '../../../../util/useQuery';

export default function PreviewArticle({ lang, detail, mode, loading, logo }) {
    const params = useQuery();
    const vendorPrivacyPolicy = detail?.vendorPrivacyPolicy;
    const vendorIntroductionLawfulBasis = detail?.vendorIntroductionLawfulBasis;
    const vendorPersonalDataCollect = detail?.vendorPersonalDataCollect;
    const vendorReasonCollectedData = detail?.vendorReasonCollectedData;
    const vendorTransferPersonalData = detail?.vendorTransferPersonalData;
    const vendorRetainPersonalData = detail?.vendorRetainPersonalData;
    const vendorDataSubjectRight = detail?.vendorDataSubjectRight;
    const vendorPolicyChange = detail?.vendorPolicyChange;

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return lang === 'TH' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'TH' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const updateDate = date?.split(' ')[0];
        const dateItem = `${updateDate?.split('/')[1]}/${
            updateDate?.split('/')[0]
        }/${updateDate?.split('/')[2]}`;
        const currentDate = new Date(dateItem);
        const day = currentDate?.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    return (
        <Spin spinning={loading}>
            <div
                className={classNames({
                    'rounded-md py-4 pl-4 pr-2 w-full border-1 max-w-4xl my-4 mx-auto bg-white':
                        !params.get('ember'),
                    'm-0 w-full !border-none ': params.get('ember') === '1',
                })}
                style={{ border: '1px solid #DBDBDB' }}
            >
                <div>
                    <div className="px-2">
                        <article className="prose max-w-full text-left">
                            <div className="text-center">
                                {vendorPrivacyPolicy?.vendorCompanyLogoId && (
                                    <img
                                        className="w-auto h-28 rounded-lg object-cover m-0"
                                        src={logo}
                                        alt={
                                            lang === 'TH'
                                                ? vendorPrivacyPolicy?.vendorCompanyNameTh
                                                : vendorPrivacyPolicy?.vendorCompanyNameEn
                                        }
                                    />
                                )}
                                <h3>
                                    {lang === 'TH'
                                        ? vendorPrivacyPolicy?.vendorPrivacyPolicyNameTh
                                        : vendorPrivacyPolicy?.vendorPrivacyPolicyNameEn}
                                </h3>
                                <p className="text-left">
                                    {vendorIntroductionLawfulBasis?.vendorIntroductionIsDisplay ===
                                    true ? (
                                        lang === 'TH' ? (
                                            parse(
                                                vendorIntroductionLawfulBasis?.vendorIntroductionContentTh ||
                                                    '-'
                                            )
                                        ) : (
                                            parse(
                                                vendorIntroductionLawfulBasis?.vendorIntroductionContentEn ||
                                                    '-'
                                            )
                                        )
                                    ) : (
                                        <></>
                                    )}
                                </p>
                            </div>
                            <h4>
                                {vendorIntroductionLawfulBasis?.vendorLawfulBasisIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorIntroductionLawfulBasis?.vendorLawfulBasisTitleTh
                                    ) : (
                                        vendorIntroductionLawfulBasis?.vendorLawfulBasisTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorIntroductionLawfulBasis?.vendorLawfulBasisIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorIntroductionLawfulBasis?.vendorLawfulBasisContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorIntroductionLawfulBasis?.vendorLawfulBasisContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorPersonalDataCollect?.vendorPersonalDataIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorPersonalDataCollect?.vendorPersonalDataTitleTh
                                    ) : (
                                        vendorPersonalDataCollect?.vendorPersonalDataTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorPersonalDataCollect?.vendorPersonalDataIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorPersonalDataCollect?.vendorPersonalDataContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorPersonalDataCollect?.vendorPersonalDataContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorPersonalDataCollect?.vendorSourceIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorPersonalDataCollect?.vendorSourceTitleTh
                                    ) : (
                                        vendorPersonalDataCollect?.vendorSourceTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorPersonalDataCollect?.vendorSourceIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorPersonalDataCollect?.vendorSourceContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorPersonalDataCollect?.vendorSourceContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorReasonCollectedData?.vendorPurposeIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorReasonCollectedData?.vendorPurposeTitleTh
                                    ) : (
                                        vendorReasonCollectedData?.vendorPurposeTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorReasonCollectedData?.vendorPurposeIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorReasonCollectedData?.vendorPurposeContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorReasonCollectedData?.vendorPurposeContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorTransferPersonalData?.vendorDisclosureIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorTransferPersonalData?.vendorDisclosureTitleTh
                                    ) : (
                                        vendorTransferPersonalData?.vendorDisclosureTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorTransferPersonalData?.vendorDisclosureIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorTransferPersonalData?.vendorDisclosureContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorTransferPersonalData?.vendorDisclosureContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorTransferPersonalData?.vendorInternationalIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorTransferPersonalData?.vendorInternationalTitleTh
                                    ) : (
                                        vendorTransferPersonalData?.vendorInternationalTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorTransferPersonalData?.vendorInternationalIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorTransferPersonalData?.vendorInternationalContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorTransferPersonalData?.vendorInternationalContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorRetainPersonalData?.vendorRetentionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorRetainPersonalData?.vendorRetentionTitleTh
                                    ) : (
                                        vendorRetainPersonalData?.vendorRetentionTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorRetainPersonalData?.vendorRetentionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorRetainPersonalData?.vendorRetentionContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorRetainPersonalData?.vendorRetentionContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorRetainPersonalData?.vendorSecurityIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorRetainPersonalData?.vendorSecurityTitleTh
                                    ) : (
                                        vendorRetainPersonalData?.vendorSecurityTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorRetainPersonalData?.vendorSecurityIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorRetainPersonalData?.vendorSecurityContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorRetainPersonalData?.vendorSecurityContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorDataSubjectRight?.vendorDataSubjectRightIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorDataSubjectRight?.vendorDataSubjectRightTitleTh
                                    ) : (
                                        vendorDataSubjectRight?.vendorDataSubjectRightTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorDataSubjectRight?.vendorDataSubjectRightIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorDataSubjectRight?.vendorDataSubjectRightContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorDataSubjectRight?.vendorDataSubjectRightContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorPolicyChange?.vendorChangeIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorPolicyChange?.vendorChangeTitleTh
                                    ) : (
                                        vendorPolicyChange?.vendorChangeTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorPolicyChange?.vendorChangeIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorPolicyChange?.vendorChangeContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorPolicyChange?.vendorChangeContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorPolicyChange?.vendorDataControllerIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorPolicyChange?.vendorDataControllerTitleTh
                                    ) : (
                                        vendorPolicyChange?.vendorDataControllerTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorPolicyChange?.vendorDataControllerIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorPolicyChange?.vendorDataControllerContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorPolicyChange?.vendorDataControllerContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {vendorPolicyChange?.vendorDataProtectionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        vendorPolicyChange?.vendorDataProtectionTitleTh
                                    ) : (
                                        vendorPolicyChange?.vendorDataProtectionTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {vendorPolicyChange?.vendorDataProtectionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            vendorPolicyChange?.vendorDataProtectionContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            vendorPolicyChange?.vendorDataProtectionContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {lang === 'TH'
                                    ? 'ฉบับ ณ วันที่'
                                    : 'Edition as of'}{' '}
                                {getCurrentDate(
                                    vendorPrivacyPolicy?.effectiveDate
                                )}
                            </h4>
                        </article>
                    </div>
                </div>
            </div>
            <div hidden={!mode}>
                <BackTop style={{ zIndex: 100000 }}>
                    <div
                        className="flex items-center justify-center !bg-[#1890ff]"
                        style={style}
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                </BackTop>
            </div>
        </Spin>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
